import './personal-optician.scss';
import React from 'react';

const PersonalOptician = props => {
    return (
        <div className="personal-optician">
            <div className="justify-content-center display-flex">
                <picture className="scooter"><img src="https://static5.lenskart.com/images/cust_mailer/Nov_27th/home_eye_checkup_opto.png" alt="home_eye_checkup_personal_optician" /></picture>
                <h4 className="personal-optician__header fsp20 fw400 text-color_grey fw600">{props.heading}</h4>
            </div>
            <p className="personal-optician__description fsp12">{props.about}</p>
        </div>
    );
};

export default PersonalOptician;
